import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/LogoJD-sin fondo.PNG';
import { FaFacebook, FaInstagram, FaBars, FaTimes,FaTiktok  } from 'react-icons/fa';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    const handleResize = () => {
      // Forzar re-render cuando cambie el tamaño de la ventana
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Calcular la opacidad del background basada en el scroll
  const getBackgroundOpacity = () => {
    // En móvil, siempre usar fondo sólido
    if (window.innerWidth < 768) {
      return 1;
    }
    
    const maxScroll = 500; // Después de 500px de scroll, el fondo será completamente sólido
    const opacity = Math.min(scrollY / maxScroll, 1);
    return opacity;
  };

  // Calcular el color de fondo con la opacidad dinámica
  const getBackgroundColor = () => {
    const opacity = getBackgroundOpacity();
    return `rgba(13, 13, 13, ${opacity})`; // brand-black (#0D0D0D) con opacidad dinámica
  };

  // Calcular el border con opacidad dinámica
  const getBorderColor = () => {
    const opacity = getBackgroundOpacity();
    return `rgba(212, 175, 55, ${opacity * 0.2})`; // brand-gold con 20% de opacidad
  };

  return (
    <>
      <header 
        className="fixed top-0 left-0 right-0 z-50 shadow-xl transition-all duration-300 ease-in-out"
        style={{ 
          backgroundColor: getBackgroundColor(),
          borderBottomColor: getBorderColor(),
          borderBottomWidth: '1px',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)'
        }}
      >
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center w-full">
            <div className="flex-shrink-0">
              <Link to="/">
                <img 
                  src={logo} 
                  alt="Logo JD Propiedad Raíz" 
                  className="h-12 md:h-16 w-auto object-contain" 
                  width="256"
                  height="192"
                />
              </Link>
            </div>

            {/* Contenedor para navegación y redes sociales en escritorio */}
            <div className="hidden md:flex items-center space-x-8">
              <nav className="flex items-center space-x-8">
                <Link to="/nosotros" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Nosotros</Link>
                <Link to="/proceso" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Proceso</Link>
                <Link to="/contacto" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Contacto</Link>
                <a href="https://wa.me/573102390002?text=Hola,%20quiero%20consignar%20mi%20propiedad." target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Consigna tu Propiedad</a>
                <a href="https://pagos.palomma.com/jdpropiedadraiz/auth/login" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Pagos</a>
                <a href="https://zonaclientes.softinm.com/jydpropiedad" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300 text-sm uppercase tracking-wider">Zona Clientes</a>

              </nav>
              <div className="flex items-center space-x-6">
                <a href="https://www.tiktok.com/@jdpropiedadraiz?_t=ZS-8z9pNchDxgn&_r=1" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
                  <FaTiktok size={20} />
                </a>
                <a href="https://www.instagram.com/jdpropiedadraiz?igsh=MWNzYjd1NzhnMDg2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
                  <FaInstagram size={20} />
                </a>
                <a href=" https://www.facebook.com/share/1Ju9mg9kBU/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
                  <FaFacebook size={20} />
                </a>
              </div>
            </div>

            {/* Botón de menú móvil */}
            <div className="block md:hidden">
              <button 
                className="text-brand-gold hover:text-brand-white transition-colors duration-300 p-2"
                onClick={toggleMenu}
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Overlay para cerrar el menú */}
      {isMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black bg-opacity-50 z-[55]"
          onClick={toggleMenu}
        />
      )}

      {/* Menú móvil lateral - movido fuera del header */}
      <div 
        className={`
          md:hidden fixed top-0 left-0 h-full w-80 border-r border-brand-gold/20 
          transform transition-transform duration-300 ease-in-out z-[60]
          ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
        style={{
          backgroundColor: 'rgb(13, 13, 13)', // Fondo sólido sin transparencia
          backdropFilter: 'none',
          WebkitBackdropFilter: 'none'
        }}
      >
        {/* Header del menú con logo y botón cerrar */}
        <div className="flex justify-between items-center p-6 border-b border-brand-gold/20">
          <img 
            src={logo} 
            alt="Logo JD Propiedad Raíz" 
            className="h-10 w-auto object-contain" 
          />
          <button 
            className="text-brand-gold hover:text-brand-white transition-colors duration-300 p-2"
            onClick={toggleMenu}
            aria-label="Close menu"
          >
            <FaTimes size={24} />
          </button>
        </div>

        <nav className="flex flex-col py-4">
          <Link 
            to="/nosotros" 
            className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10"
            onClick={toggleMenu}
          >
            Nosotros
          </Link>
          <Link 
            to="/proceso" 
            className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10"
            onClick={toggleMenu}
          >
            Proceso
          </Link>
          <Link 
            to="/contacto" 
            className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10"
            onClick={toggleMenu}
          >
            Contacto
          </Link>
          <a href="https://wa.me/573102390002?text=Hola,%20quiero%20consignar%20mi%20propiedad." className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10" onClick={toggleMenu}>
            Consigna tu Propiedad
          </a>
          <a href="https://pagos.palomma.com/jdpropiedadraiz/auth/login" className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10" onClick={toggleMenu}>
            Pagos
          </a>
          <a href="https://zonaclientes.softinm.com/jydpropiedad" className="text-brand-gold hover:text-brand-white transition-colors duration-300 px-6 py-4 text-sm uppercase tracking-wider border-b border-brand-gold/10" onClick={toggleMenu}>
            Zona Clientes
          </a>

          {/* Redes sociales en menú móvil */}
          <div className="flex justify-center space-x-6 mt-8 py-4 border-t border-brand-gold/20">
            <a href="https://www.tiktok.com/@jdpropiedadraiz?_t=ZS-8z9pNchDxgn&_r=1" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
              <FaTiktok size={24} />
            </a>
            <a href="https://www.instagram.com/jdpropiedadraiz?igsh=MWNzYjd1NzhnMDg2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
              <FaInstagram size={24} />
            </a>
            <a href=" https://www.facebook.com/share/1Ju9mg9kBU/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-brand-gold hover:text-brand-white transition-colors duration-300">
              <FaFacebook size={24} />
            </a>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
